import ProductCardSkeleton from "./product-card-skeleton";

export default function ProductListSkeleton({ count = 6, className = "" }) {
  return (
    <div className={`grid sm:grid-cols-2 lg:grid-cols-3 gap-8 ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </div>
  );
}

